__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "sls-data-portal";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@headlessui/react", "2.2.7", () => (Promise.all([__webpack_require__.e(153), __webpack_require__.e(212), __webpack_require__.e(98), __webpack_require__.e(116)]).then(() => (() => (__webpack_require__(3153))))));
			register("@reduxjs/toolkit", "2.9.0", () => (Promise.all([__webpack_require__.e(222), __webpack_require__.e(673)]).then(() => (() => (__webpack_require__(673))))));
			register("@superset-ui/embedded-sdk", "0.3.0", () => (Promise.all([__webpack_require__.e(748), __webpack_require__.e(56)]).then(() => (() => (__webpack_require__(3748))))));
			register("formik", "2.4.6", () => (Promise.all([__webpack_require__.e(423), __webpack_require__.e(212)]).then(() => (() => (__webpack_require__(423))))));
			register("jwt-decode", "4.0.0", () => (__webpack_require__.e(420).then(() => (() => (__webpack_require__(4420))))));
			register("react-dom", "19.1.0", () => (Promise.all([__webpack_require__.e(212), __webpack_require__.e(950)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(212), __webpack_require__.e(3)]).then(() => (() => (__webpack_require__(3003))))));
			register("react-router-dom", "7.18.1", () => (Promise.all([__webpack_require__.e(480), __webpack_require__.e(212), __webpack_require__.e(98), __webpack_require__.e(735)]).then(() => (() => (__webpack_require__(2480))))));
			register("react", "19.1.0", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			register("yup", "1.7.0", () => (__webpack_require__.e(44).then(() => (() => (__webpack_require__(6044))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};